$(function() {

    $('.srr-betterselect').select2();

});
